module.exports = __webpack_public_path__ + "static/media/water-heater.0eb70c63.png";